export function generalAction(type: string, result: any, rest: any) {
  if (typeof result === 'undefined' || result === null) {
    return { type, ...rest };
  }

  return { type, result, ...rest };
}

export function createAction(type: string, payload = {}, parent = null, showNotification = true) {
  return {
    type,
    payload,
    error: payload instanceof Error,
    parent,
    showNotification,
  };
}
